<template>
  <div>
    <div>
      <v-tabs v-model="tab" bg-color="#2d2d2d">
        <v-tab v-for="(t, i) in tabs" :key="i">{{ t.label }}</v-tab>
      </v-tabs>

      <v-window v-model="tab">
        <v-window-item
          v-for="(t, i) in tabs"
          :key="i"
          :value="i"
          transition="none"
          reverse-transition="none"
        >
          <prism :language="t.lang" class="highlight">
            {{ getSnippet(t.key) }}
          </prism>
        </v-window-item>
      </v-window>
    </div>
  </div>
</template>

<script>
  import Prism from 'vue-prism-component'
  import 'prismjs'
  import 'prismjs/themes/prism-tomorrow.css'
  import 'prismjs/components/prism-markup-templating'
  import 'prismjs/components/prism-php'
  import 'prismjs/components/prism-python'
  import 'prismjs/components/prism-bash'

  export default {
    name: 'CodeSamples',
    props: ['location', 'auth', 'componentKey', 'request'],
    data() {
      return {
        tab: 0,
        tabs: [
          { label: 'PHP-cURL', lang: 'php', key: 'php' },
          { label: 'JS-JQUERY', lang: 'javascript', key: 'jquery' },
          { label: 'JS-XHR', lang: 'javascript', key: 'xhr' },
          { label: 'NODEJS-AXIOS', lang: 'javascript', key: 'axios' },
          { label: 'cURL', lang: 'bash', key: 'curl' },
          { label: 'PYTHON', lang: 'python', key: 'python' },
        ],
      }
    },
    components: {
      Prism,
    },
    methods: {
      getSnippet(type) {
        const url = `${this.location}?authkey=${this.auth}`

        switch (type) {
          case 'php':
            return `$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => '${url}',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'GET',
));

$response = curl_exec($curl);
curl_close($curl);
echo $response;`

          case 'jquery':
            return `var settings = {
  url: "${url}",
  method: "GET",
  timeout: 0,
};

$.ajax(settings).done(function (response) {
  console.log(response);
});`

          case 'xhr':
            return `var xhr = new XMLHttpRequest();
xhr.withCredentials = true;

xhr.addEventListener("readystatechange", function () {
  if (this.readyState === 4) {
    console.log(this.responseText);
  }
});

xhr.open("GET", "${url}");
xhr.send();`

          case 'axios':
            return `var axios = require('axios');

var config = {
  method: 'get',
  url: '${url}',
  headers: {}
};

axios(config)
  .then(function (response) {
    console.log(JSON.stringify(response.data));
  })
  .catch(function (error) {
    console.log(error);
  });`

          case 'curl':
            return `curl --location --request GET '${url}'`

          case 'python':
            return `import requests

url = "${url}"
payload = {}
headers = {}

response = requests.request("GET", url, headers=headers, data=payload)
print(response.text)`
        }

        return '// Snippet not available'
      },
    },
  }
</script>

<style scoped>
  .highlight {
    min-height: 525px;
    background-color: #2d2d2d;
    font-size: 0.85rem;
  }
</style>
